export default __webpack_public_path__ + "static/core-collection-desktop-f719e657b498db4261bee3ee7025bccd.webp";